export enum IconRootNameEnum {
  icon = 'icon',
  primeng = 'pi',
}
